<template>
  <IQOS :title="$t('preorder_time_flag.title')" :readonly="false" :class="{
      'iqos-transparent': !value
  }">
    <p class="comment pt-0 c-gray">
        {{ $t('preorder_time_flag.desc') }}
    </p>

    <IQOSToggle v-model="value" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSToggle from "@/components/IQOSToggle.vue";

export default {
  components: {
    IQOS,
    IQOSToggle
  },
  computed: {
    value: {
      get() {
        return this.$store.state.cafe.preorder.allow_specific_time;
      },
      set(v) {
        this.$store.commit("setPreorderTimeFlag", v);
        this.$store.dispatch("saveCafe");
      },
    },
  },
};
</script>

<style>
</style>